import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import { SvgProvider } from '@argos/svg'
import { ArgosTheme } from '@boltui/themes'

import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'

import { ScrollPositionProvider } from '../helpers/scrollPositionContext'

const MainLayout = ({ children, history }) => (
  <ThemeProvider theme={ArgosTheme}>
    <ScrollPositionProvider>
      <SvgProvider>
        <div data-test='app' className='app'>
          <div>
            <Header history={history} />
          </div>
          <div id='app-content' className='app-content container'>
            <main>{children}</main>
          </div>
          <div className='bolt-v2'>
            <Footer />
          </div>
        </div>
      </SvgProvider>
    </ScrollPositionProvider>
  </ThemeProvider>
)

MainLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
  history: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
}

export default MainLayout
